<template>
  <div class="row">
    <img class="opacityImage" src="../images/logo_.png" />
    <div class="menu">
      <div id="optionbar">
        <div class="head-all-icon" >
              <div class="head-item-icon">
                <a href="https://www.facebook.com/hkexplorer.talent/" target="_Blank" tabindex="1">
                  <i class="icon-facebook"></i>
                </a>
              </div>
              <div class="head-item-icon">
            
                <a href="https://www.instagram.com/hk.talent/?igshid=1ax8dv4hofn1k" target="_Blank" tabindex="2">
                    <i class="icon-icon-svg-28"></i>
                </a>
              </div>
              <div class="head-item-icon">
                <a href="https://www.linkedin.com/company/explorer-mip/" target="_Blank" tabindex="3">
                  <i class="icon-in"></i>
                </a>
              </div>
            
            </div>
        <div class="clearfix">
          <span class="fontSize Bold setSize">
            <a
              href="javascript:;"
              v-on:click="changeFontSize(0)"
              class="smallFont"
              :class="fontSize=='0'?'active':''"
              tabindex="4"
            >A</a>
            <a
              href="javascript:;"
              v-on:click="changeFontSize(1)"
              class="middleFont"
              :class="fontSize=='1'?'active':''"
              tabindex="5"
            >A</a>
            <a
              href="javascript:;"
              v-on:click="changeFontSize(2)"
              class="largeFont"
              :class="fontSize=='2'?'active':''"
              tabindex="6"
            >A</a>
          </span>
          <span class="language ">
            <a
              href="javascript:;"
              v-if="language!='en_US'"
              v-on:click="changeLanguage('en_US')"
              class="EN"
              tabindex="7"
            >ENG</a>
            <span class="TC NotoSansTC-Medium" v-if="language=='zh_CN'">|</span>
            <a
              href="javascript:;"
              v-if="language!='zh_HK'"
              v-on:click="changeLanguage('zh_HK')"
              class="TC NotoSansTC-Medium"
              tabindex="8"
            >繁</a>
            <span class="TC NotoSansTC-Medium" v-if="language!='zh_CN'">|</span>
            <a
              href="javascript:;"
              v-if="language!='zh_CN'"
              v-on:click="changeLanguage('zh_CN')"
              class="SC NotoSansTC-Medium"
              tabindex="9"
            >简</a>
          </span>
        </div>
      </div>
      <ul id="navbar" class="SemiBold" :class="{'zhongwen':language!='en_US'}">
        <li class v-on:click="navTo('magazine','Online Magazine')">
          <a
            href="javascript:;"
            class="header__link transition--color _100werz"
            :class="{'is-active':$store.state.selectMenu==1}"
            tabindex="10"
          >
            <h4 class="magazineMenu">{{ $t(("message.Online Magazine")) }}<img class="iconImg" src="../images/logo-05.png" /></h4>
            <span class="_480t39 __underline"></span>
          </a>
        </li>
        <li class v-on:click="navTo('browseOccupations','Browse Occupations')">
          <a
            href="javascript:;"
            class="header__link transition--color _100werz"
            :class="{'is-active':$store.state.selectMenu==2}"
            tabindex="11"
          >
            <h4>{{$t(("message.Browse Occupations"))}}<i class="icon-search" aria-hidden="true"></i></h4>
            <span class="_480t39 __underline"></span>
          </a>
        </li>
        <li class v-on:click="navTo('findAnOpportunity','Find An Opportunity')">
          <a
            href="javascript:;"
            class="header__link transition--color _100werz"
            :class="{'is-active':$store.state.selectMenu==3}"
            tabindex="12"
          >
            <h4>{{ $t(("message.Find a Job Opportunity")) }}<i class="icon-search" aria-hidden="true"></i></h4>
            <span class="_480t39 __underline"></span>
          </a>
        </li>
        <li class v-on:click="navTo('browseCourses','Browse Courses')">
          <a
            href="javascript:;"
            class="header__link transition--color _100werz"
            :class="{'is-active':$store.state.selectMenu==4}"
            tabindex="13"
          >
            <h4>{{ $t(("message.Browse Courses")) }}<i class="icon-search" aria-hidden="true"></i></h4>
            <span class="_480t39 __underline"></span>
          </a>
        </li>
        <li class v-on:click="navTo('selfAssessment','Self Assessment')">
          <a
            href="javascript:;"
            class="header__link transition--color _100werz"
            :class="{'is-active':$store.state.selectMenu==5}"
            tabindex="14"
          >
            <h4>{{ $t(("message.Self-Assessment")) }}</h4>
            <span class="_480t39 __underline"></span>
          </a>
        </li>
      </ul>
    </div>
    <div class="mobile-menu">
      <div class="mobile-topbar "> 
        <div class="logoMip pointer" v-on:click="navTo('home','Home')"><img src="../images/logo.png" alt="talent.gov.hk Logo" /></div>
        <div class="pull-right">
          <a class="menu-icon" v-if="!isShowMenu" v-on:click="showMenu()">
            <i class="icon-menu"></i>
          </a>
        </div>
      </div>
      <div :style="{'height':$store.state.innerHeight + 'px', position:(isMagazine? 'fixed':'')}" ref="mobile"  :class="isShowMenu?'visible mobile-navbar':'mobile-navbar'">
        <div class="mobile-content" ref="mobileContent">
          <div class="pull-right">
            <a class="menu-icon" v-if="isShowMenu" v-on:click="closeMenu()">
              <i class="icon-close"></i>
            </a>
          </div>
          <ul class="Bold mainColor sideMenuSize">
            <li v-on:click="navTo('home','Home')" class="delay-10">
              <h4>{{ $t(("message.Home")) }}</h4>
            </li>
            <li v-on:click="navTo('magazine','Online Magazine')" class="delay-15">
              <h4>{{ $t(("message.Online Magazine")) }}<img class="iconImg" src="../images/logo-05.png" /></h4>
            </li>
            <li v-on:click="navTo('browseOccupations','Browse Occupations')" class="delay-20">
              <h4>{{ $t(("message.Browse Occupations")) }}<i class="icon-search" aria-hidden="true"></i></h4>
            </li>
            <li v-on:click="navTo('findAnOpportunity','Find An Opportunity')" class="delay-25">
              <h4>{{ $t(("message.Find a Job Opportunity")) }}<i class="icon-search" aria-hidden="true"></i></h4>
            </li>
            <li v-on:click="navTo('browseCourses','Browse Courses')" class="delay-30">
              <h4>{{ $t(("message.Browse Courses")) }}<i class="icon-search" aria-hidden="true"></i></h4>
            </li>
            <li v-on:click="navTo('selfAssessment','Self Assessment')" class="delay-35">
              <h4>{{ $t(("message.Self-Assessment")) }}</h4>
            </li>
          </ul>
          <div id="mobile-optionbar" class="NotoSansTC-Bold" >
              <div class="header-all-icon" v-if="$store.state.innerWidth<=992 & isShowMenu">
              <div class="header-item-icon">
                <a href="https://www.facebook.com/hkexplorer.talent/" target="_Blank">
                  <i class="icon-facebook"></i>
                </a>
              </div>
              <div class="header-item-icon">
            
                <a href="https://www.instagram.com/hk.talent/?igshid=1ax8dv4hofn1k" target="_Blank">
                    <i class="icon-icon-svg-28"></i>
                </a>
              </div>
              <div class="header-item-icon">
                <a href="https://www.linkedin.com/company/hk-talent/" target="_Blank">
                  <i class="icon-in"></i>
                </a>
              </div>
            
            </div>
            <div class="seclect-languageTwo" v-show="isShowMenu">
              <!-- <img src="../images/google translate.png" alt /> -->
              <div id="google_translate_element_mobile"></div>
            </div>
            <span class="language">
              <a
                href="javascript:;"
                v-if="language!='en_US' && isShowMenu"
                v-on:click="changeLanguage('en_US')"
                class="EN mainColor"
              >ENG</a>
              <a
                href="javascript:;"
                v-if="language!='zh_HK' && isShowMenu"
                v-on:click="changeLanguage('zh_HK')"
                class="TC mainColor"
              >繁</a>
              <a
                href="javascript:;"
                v-if="language!='zh_CN' && isShowMenu"
                v-on:click="changeLanguage('zh_CN')"
                class="SC mainColor"
              >简</a>
            </span>
              <span>|</span>
            <span class="fontSize">
              <a
                href="javascript:;"
                v-if="isShowMenu"
                v-on:click="changeFontSize(2)"
                class="largeFont mainColor"
                :class="fontSize=='2'?'active':''"
              >A</a>
              <a
                v-if="isShowMenu"
                href="javascript:;"
                v-on:click="changeFontSize(1)"
                class="middleFont mainColor"
                :class="fontSize=='1'?'active':''"
              >A</a>
              <a
                v-if="isShowMenu"
                href="javascript:;"
                v-on:click="changeFontSize(0)"
                class="smallFont mainColor"
                :class="fontSize=='0'?'active':''"
              >A</a>
            </span>
            <div class="header-placeImg">
             
            </div>
          </div>
          <div class="footerImg">
             <img src="../images/Group 3.png" />
          </div>
          <div class="headerImg">
            <img src="../images/line5.png" />
          </div>
        </div>
      </div>
      <div class="seclect-language">
        <div id="google_translate_element"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowMenu: false,
      transitionDelay: [
        [
          { "transition-delay": "0.1s" },
          { "-webkit-transition-delay": "0.1s" },
          { "-moz-transition-delay": "0.1s" },
          { "-ms-transition-delay": "0.1s" }
        ],
        [
          { "transition-delay": "0.15s" },
          { "-webkit-transition-delay": "0.15s" },
          { "-moz-transition-delay": "0.15s" },
          { "-ms-transition-delay": "0.15s" }
        ],
        [
          { "transition-delay": "0.2s" },
          { "-webkit-transition-delay": "0.2s" },
          { "-moz-transition-delay": "0.2s" },
          { "-ms-transition-delay": "0.2s" }
        ],
        [
          { "transition-delay": "0.25s" },
          { "-webkit-transition-delay": "0.25s" },
          { "-moz-transition-delay": "0.25s" },
          { "-ms-transition-delay": "0.25s" }
        ],
        [
          { "transition-delay": "0.3s" },
          { "-webkit-transition-delay": "0.3s" },
          { "-moz-transition-delay": "0.3s" },
          { "-ms-transition-delay": "0.3s" }
        ],
        [
          { "transition-delay": "0.35s" },
          { "-webkit-transition-delay": "0.35s" },
          { "-moz-transition-delay": "0.35s" },
          { "-ms-transition-delay": "0.35s" }
        ]
      ],
      showTransition: [],
      showNum: 0,
      language: this.$store.state.language,
      fontSize: 0,
      googleL:'en',
    };
  },
  props:[
    "logGaEvent",
    "isMagazine",
  ],
  computed:{
    innerwidth(){
      return this.$store.state.innerWidth;
    }
  },
  methods: {
    checkWidth:function(){
      this.$refs.mobileContent.style.height= window.innerHeight + 'px';
        this.$refs.mobile.style.height = window.innerHeight + 'px';
        document.body.style.height =  window.innerHeight + 'px';
      
       
    },
      setHight: function() {
          this.$refs.mobile.style.height = window.innerHeight + 'px';
          this.$refs.mobileContent.style.height = window.innerHeight + 'px';
      },
      overflowY:function(){
        document.body.style.overflow= "hidden";
        
      },
      freedOverflowY:function(){
         document.body.style.overflow = "scroll";
       
      },
      setGoogleLanguage:function(){
        document.getElementById("google_translate_element").innerHTML = "";
        document.getElementById("google_translate_element_mobile").innerHTML = "";
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit')
        document.head.appendChild(recaptchaScript)
      }
  },

  mounted() {
    this.$store.state.fontSize = 0;
    var that = this;
    this.changeFontSize = function(sizeNum) {
      window.document.documentElement.setAttribute("data-size", sizeNum);
      let fontSizeName=""
      switch(sizeNum){
        case 0:
          fontSizeName="smallFont"
          break;
        case 1:
          fontSizeName="middleFont"
          break;
        case 2:
          fontSizeName="largeFont"
          break;
      }
      this.logGaEvent('userClick','fontSize',fontSizeName)
      this.$store.state.fontSize = sizeNum;
      this.fontSize = sizeNum;
    };
    this.showMenu = function() {
      if(this.$store.state.isPreview) return;
      this.overflowY();
     
      this.transitionDelay = [
        [
          { "transition-delay": "0.1s" },
          { "-webkit-transition-delay": "0.1s" },
          { "-moz-transition-delay": "0.1s" },
          { "-ms-transition-delay": "0.1s" }
        ],
        [
          { "transition-delay": "0.15s" },
          { "-webkit-transition-delay": "0.15s" },
          { "-moz-transition-delay": "0.15s" },
          { "-ms-transition-delay": "0.15s" }
        ],
        [
          { "transition-delay": "0.2s" },
          { "-webkit-transition-delay": "0.2s" },
          { "-moz-transition-delay": "0.2s" },
          { "-ms-transition-delay": "0.2s" }
        ],
        [
          { "transition-delay": "0.25s" },
          { "-webkit-transition-delay": "0.25s" },
          { "-moz-transition-delay": "0.25s" },
          { "-ms-transition-delay": "0.25s" }
        ],
        [
          { "transition-delay": "0.3s" },
          { "-webkit-transition-delay": "0.3s" },
          { "-moz-transition-delay": "0.3s" },
          { "-ms-transition-delay": "0.3s" }
        ],
        [
          { "transition-delay": "0.35s" },
          { "-webkit-transition-delay": "0.35s" },
          { "-moz-transition-delay": "0.35s" },
          { "-ms-transition-delay": "0.35s" }
        ]
      ];
      this.isShowMenu = true;
      this.$parent.openMenuEvent();
    };
    this.closeMenu = function() {
      this.freedOverflowY();
      this.transitionDelay = [];
      this.isShowMenu = false;
      this.$parent.closeMenuEvent();
    };
    this.navTo = function(path,name) {
      if(path=="magazine"){
        this.$store.state.formData.headTabState1 = true;
      }else if(path=="browseOccupations"){
        this.$store.state.formData.headTabState2 = true;
      }else if(path=="findAnOpportunity"){
        this.$store.state.formData.headTabState3 = true;
      }else if(path=="browseCourses"){
        this.$store.state.formData.headTabState4 = true;
      }
      

      this.freedOverflowY();
      this.logGaEvent('userClick','menu',name)
      this.closeMenu();
      this.$router.push({
          path:"/" + path,
          query:{lang:this.$store.state.language}
      })
      // body...
    };
    googleTranslateElementInit = function() {
      if(window.innerWidth>1080)
        new google.translate.TranslateElement({pageLanguage: that.googleL}, 'google_translate_element');
      else
        new google.translate.TranslateElement({pageLanguage: that.googleL}, 'google_translate_element_mobile');
    }

    this.changeLanguage = function(language) {
      window.document.documentElement.setAttribute("data-language", language);
      this.logGaEvent('userClick','language',language)
      this.$store.commit("setLanguage", language);
      // 
      this.language = this.$store.state.language;
      this.$i18n.locale = language;
      this.$store.state.mate.description = this.$i18n.t("message.description");
      if(!this.$route.query.lang||this.$route.query.lang!=this.language){
        this.$router.push({query: {lang: language,name:this.$route.query.name}})
      }
      if(language=="zh_CN"){
        that.googleL = "zh-CN"
      }else if(language=="zh_HK"){
        that.googleL = "zh-TW"
      }else{
        that.googleL = "en";
      }
      this.setGoogleLanguage();
    };
    if(this.$route.query.lang){
      this.changeLanguage(this.$route.query.lang);
      return;
    }else{
      var language = navigator.language;
      if(language=="zh-TW"||language=="zh-HK"){
          this.changeLanguage("zh_HK");
      }else if(language=="zh-CN"){
          this.changeLanguage("zh_CN");
      }else{
          this.changeLanguage("en_US");
      }
    }
  },
  watch:{
    innerwidth(news,old) {
       this.checkWidth();
    },
  }
};
</script>